<template>
    <div class="quotation-lines-view">
        <div v-if="lines.length > 0" class="lines-list">
            <div
                v-for="(line, index) in lines"
                :key="index"
                class="line-row mb-3 p-3 border rounded"
            >
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="d-flex align-items-start">
                            <div v-if="line.item && line.item.image" class="item-image-container mr-3">
                                <img 
                                    :src="line.item.image" 
                                    :alt="line.item.name"
                                    class="item-thumbnail"
                                    @click="showImageModal(line.item.image)"
                                />
                            </div>
                            <div v-else-if="line.source_item && line.source_item.image" class="item-image-container mr-3">
                                <img 
                                    :src="line.source_item.image" 
                                    :alt="line.source_item.name"
                                    class="item-thumbnail"
                                    @click="showImageModal(line.source_item.image)"
                                />
                            </div>
                            <div class="flex-grow-1">
                                <h6>
                                    <span v-if="line.item">{{ line.item.name }} - {{ line.item.reference }}</span>
                                    <span v-else-if="line.is_labor_of_item && line.source_item">
                                        Mano de Obra de: {{ line.source_item.name }} - {{ line.source_item.reference }}
                                    </span>
                                    <span v-else-if="line.source_item && !line.is_labor_of_item">
                                        Accesorios de: {{ line.source_item.name }} - {{ line.source_item.reference }}
                                    </span>
                                    <span v-else>{{ line.item_manual || 'Item manual' }}</span>
                                </h6>
                                <p class="text-muted small mb-1">
                                    <strong>Precio Unitario:</strong> {{ formatCurrency(line.unit_price, line.currency || 'COP') }}
                                </p>
                                <p class="text-muted small" v-if="line.item && line.item.description">
                                    {{ line.item.description }}
                                </p>
                                <p class="text-muted small" v-if="line.is_labor_of_item && line.source_item && line.source_item.description">
                                    {{ line.source_item.description }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <p><strong>Cantidad:</strong> {{ line.quantity || line.days || 0 }}</p>
                        <p v-if="line.currency === 'USD' && line.trm_used">
                            <strong>TRM:</strong> {{ formatCurrency(line.trm_used) }}
                        </p>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-md-12">
                        <div class="line-calculations">
                            <small class="text-muted">
                                Subtotal: {{ formatCurrency(line.subtotal || 0) }} | 
                                <strong>Total COP: {{ formatCurrency(line.subtotal_after_multiplier || 0) }}</strong>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="text-center text-muted p-4">
            <p>No hay items en esta categoría</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        categorySlug: {
            type: String,
            required: true
        },
        categoryName: {
            type: String,
            required: true
        },
        lines: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        formatCurrency(value, currency = 'COP') {
            if (!value && value !== 0) return '$ 0,00';
            return new Intl.NumberFormat('es-CO', {
                style: 'currency',
                currency: currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(value);
        },
        showImageModal(imageUrl) {
            window.open(imageUrl, '_blank');
        }
    }
};
</script>

<style scoped>
.quotation-lines-view {
    padding: 10px;
}

.line-row {
    background: #f8f9fa;
}

.line-calculations {
    border-top: 1px solid #dee2e6;
    padding-top: 10px;
    margin-top: 10px;
}

.item-image-container {
    flex-shrink: 0;
}

.item-thumbnail {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 6px;
    cursor: pointer;
    transition: transform 0.2s ease;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    border: 1px solid #dee2e6;
}

.item-thumbnail:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}
</style>

